import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[cignaTrimInputWhitespace]',
})
export class TrimInputWhitespaceDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('blur', ['$event'])
  @HostListener('paste', ['$event'])
  onEvent($event: any) {
    if ($event.type === 'blur' && this.control && this.control.control) {
      const data = this.control['control'].value;
      this.control['control'].setValue(data.trim(data));
    }
    if ($event.type === 'paste') {
      $event.preventDefault(); // blocks write to input element
      const data = ($event.clipboardData || (window as any).clipboardData) // window is for IE
        .getData('text');
      if (this.control && this.control.control) {
        this.control['control'].setValue(data.trim());
      }
    }
  }
}
